import Rest from '@services/Rest';

/**
 * @typedef {IdentityDownloadService}
 */
export default class IdentityDownloadService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/identity-validation/download'
}
